import { useMemo } from 'react';

import {
  FeatureToggle,
  USER_NAV_ITEMS as STATIC_USER_NAV_ITEMS,
  USER_NAV_ITEMS_KEYS,
  routes,
} from '@fly/shared';
import { useFeatureToggle } from '@fly/shared-hooks';
import { useGetCurrentUserProfileQuery } from '@fly/store';

export const useUserNavItems = () => {
  const { hasFeature } = useFeatureToggle();
  const { data: currentUser } = useGetCurrentUserProfileQuery();

  return useMemo(() => {
    const items = { ...STATIC_USER_NAV_ITEMS };
    const accountTitleKey = 'app.dashboard.header.user_menu.account.title';
    const workspaceTitleKey = 'app.dashboard.header.user_menu.workspace.title';
    if (items[accountTitleKey]) {
      items[accountTitleKey] = [...items[accountTitleKey]];

      if (hasFeature(FeatureToggle.PAYMENT) && currentUser?.isAdmin) {
        items[accountTitleKey].push({
          title: USER_NAV_ITEMS_KEYS.PAYMENT,
          path: routes.DASHBOARD.ACCOUNT.PAYMENT,
          svgIcon: 'payment',
        });
      }
    }

    if (items[workspaceTitleKey] && !hasFeature(FeatureToggle.SLACK)) {
      items[workspaceTitleKey] = items[workspaceTitleKey].filter(
        (item) => item.title !== USER_NAV_ITEMS_KEYS.SETTINGS
      );
    }
    return items;
  }, [currentUser?.isAdmin, hasFeature]);
};
